import React from 'react';
import BureauMember from '../components/BureauMember';
import '../styles/Bureau.css';

const Bureau = () => {
  const members = [
    {
      name: "Isabelle NACOULMA",
      role: "Président",
      image: "/images/bureau/president.jpg",
      description: "Leader visionnaire et présentant à l'EISMV de Dakar, elle incarne l'engagement et la passion qui animent notre association.",
      email: "president@association.com",
      linkedin: "#"
    },
    {
      name: "Jacques ILLY",
      role: "Secrétaire Général", 
      image: "/images/bureau/secretaire.jpg",
      description: "élève ingénieure statisticien économistes, le chargé à l'organisation au sein de l'amicale à l'ENSAE et  également le secrétariat général de l'ASB.",
      email: "secretaire@association.com",
      linkedin: "https://www.linkedin.com/in/jacques-illy-9929b535a?trk=contact-info"
    },
    {
      name: "Nouriatou BARA",
      role: "Trésorière",
      image: "/images/bureau/tresorier.jpg", 
      description: " Etudiante de nationalité burkinabé à l’EISMV de Dakar. Passionnée par la médecine, la littérature, les voyages et la découverte . Dynamique , elle aime se sentir utile pour sa communauté.",
      email: "atifabara@gmail.com",
      linkedin: "https://www.linkedin.com/in/nouriatou-atifa-bara-813b30245?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
    }
    ,
    {
      name: "Nassour KINDA",
      role: "Secrétaire à la communication",
      image: "/images/bureau/communication.jpg", 
      description: "Etudiant en 4e année à l'Ecole Inter-Etats des Sciences et Médecine Vétérinaires (E.I.S.M.V.) de Dakar. Animé par le sens du collectif et la rigueur scientifique  ",
      email: "tresorier@association.com",
      linkedin: "https://www.linkedin.com/in/nassour-kinda-596054334"
    }
    ,
    {
      name: "Ben Idriss SOMA",
      role: "Secrétaire aux relations extérieurs",
      image: "/images/bureau/relations.jpg", 
      description: "Présentement à l'ENSAE de Dakar , très dynamique et toujours prêt à relever de nouveaux défis.",
      email: "tresorier@association.com",
      linkedin: "https://www.linkedin.com/in/ben-soma-82a85a1b1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
    }
    ,
    {
      name: "Salimata Yasmine ZOUON",
      role: "Secrétaire à l’organisation",
      image: "/images/bureau/organisation.jpg", 
      description: "Etudiante à l'Université Cheikh Anta Diop de Dakar, elle est passionnée par la gestion d'événements et la coordination d'équipes.",
      email: "tresorier@association.com",
      linkedin: "#"
    }
    ,
    {
      name: "Severin BAYALA",
      role: "Secrétaire au Sport",
      image: "/images/bureau/sport.jpg", 
      description: "Actuellement au CESAG de Dakar, il est passionné par le sport et la promotion d'un mode de vie sain au sein de notre communauté.",
      email: "tresorier@association.com",
      linkedin: "https://www.linkedin.com/in/data-analyst-finance-quantitative-intelligence-artificielle?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    }
  ];

  return (
    <div className="bureau-container">
      {/* Hero Section */}
      <div className="bureau-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <div className="badge-indicator"></div>
           
          </div>
          
          <h1 className="hero-title">Notre Bureau</h1>
          
          <p className="hero-description">
            Découvrez l'équipe dirigeante qui guide notre vision et porte nos valeurs au quotidien
          </p>
        </div>
      </div>

      {/* Members Section */}
      <div className="bureau-members">
        <div className="members-grid">
          {members.map((member, index) => (
            <div
              key={index}
              className="member-wrapper"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <BureauMember member={member} />
            </div>
          ))}
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
    </div>
  );
};

export default Bureau;